import React, { useEffect, useState } from 'react';
import GridSelect from './GridSelect';
import { getLookup } from '../../services/clinicPortalServices/lookupService';

// Drop-in for a plain <select>{<option>s}</select> (or react-bootstrap Form.Select): 7+ options become a searchable grid; small lists stay a dropdown.
const flatten = (children) => {
    const out = [];
    React.Children.forEach(children, (ch) => {
        if (!ch) return;
        if (ch.type === React.Fragment) out.push(...flatten(ch.props.children));
        else out.push(ch);
    });
    return out;
};
const textOf = (n) => (typeof n === 'string' || typeof n === 'number' ? String(n) : Array.isArray(n) ? n.map(textOf).join('') : n && n.props ? textOf(n.props.children) : '');

export default function GridNativeSelect(props) {
    const { name, value, onChange, disabled, minForGrid = 7, gridLabel, multiple, lookup, ...rest } = props;
    let { children } = props;
    const [lookupItems, setLookupItems] = useState(null);
    useEffect(() => {
        if (!lookup) return undefined;
        let alive = true;
        getLookup(lookup).then((d) => { if (alive) setLookupItems(d || []); });
        return () => { alive = false; };
    }, [lookup]);
    if (lookup && lookupItems) children = [<option key="" value="">Please Select</option>, ...lookupItems.map((i) => <option key={i.value} value={i.value}>{i.label}</option>)];
    const items = flatten(children).filter((ch) => ch && ch.props);
    const options = items
        .map((ch) => ({ value: ch.props.value !== undefined ? ch.props.value : textOf(ch.props.children), label: textOf(ch.props.children), disabled: ch.props.disabled }))
        .filter((o) => o.value !== '' && !o.disabled && !/^please select/i.test(o.label));
    if (multiple || options.length < minForGrid) {
        return <select name={name} value={value} onChange={onChange} disabled={disabled} multiple={multiple} {...rest}>{children}</select>;
    }
    return (
        <GridSelect
            label={gridLabel || ''}
            value={value}
            options={options}
            disabled={disabled}
            placeholder="Search…"
            onChange={(v) => onChange && onChange({ target: { name, value: v }, persist: () => {}, preventDefault: () => {} })}
        />
    );
}
